export * from './esm-es5/index.mjs';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ionic/core/dist/index.mjs
// module id = 74
// module chunks = 1